import React from "react";
import { Tabs } from "antd";
import styled from "@emotion/styled";
import Candidates from "./Candidates";
import Pipeline from "./Pipeline";
import Team from "./Team";



const CustomTabs = styled(Tabs)`
  && .ant-tabs-nav-wrap {
    padding-left: 5.3%;
  }

  && .ant-tabs-tab-btn {
    font-size: 16px !important;
  }

  && .ant-tabs-ink-bar {
    position: absolute;
    background: #1677ff;
    pointer-events: none;
    height: 3px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;
const JobDetails2 = (props) => {
  const onChange = (key) => {
    console.log(key);
  };

  
const items = [
  {
    key: "Candidates",
    label: "Candidates",
    children: <Candidates {...props} />,
  },
  {
    key: "Pipeline",
    label: "Pipeline",
    children: <Pipeline {...props} />,
  },
  {
    key: "Team",
    label: "Team",
    children: <Team {...props} />,
  },
];

  return (
    <CustomTabs
      defaultActiveKey="Candidates"
      items={items}
      onChange={onChange}
    />
  );
};
export default JobDetails2;
